import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "uk-modal-dialog uk-modal-body" }
const _hoisted_3 = { class: "uk-modal-title" }
const _hoisted_4 = { class: "input-wrapper uk-margin-small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_template_slug_form = _resolveComponent("template-slug-form")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.modalId,
    "uk-modal": "",
    class: "basic-modal",
    onBeforeshow: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showForm = true)),
    onHidden: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm = false))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('shared.modals.template_slug.title')), 1),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.showForm)
          ? (_openBlock(), _createBlock(_component_template_slug_form, {
              key: 0,
              slug: _ctx.store.state.templates.slug,
              submittable: _ctx.submittable,
              onSubmit: _ctx.submitHandler
            }, null, 8, ["slug", "submittable", "onSubmit"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 40, _hoisted_1))
}